// From react documentation https://reactjs.org/docs/error-boundaries.html

import { PropsWithChildren, Component } from 'react';
import { ErrorPage } from '../../../views/error-view';

interface Props {
  pathname: string;
}
interface State {
  hasError: boolean;
  pathname: string | undefined;
}

export class AppError extends Component<PropsWithChildren<Props>, State> {
  private defaultState: State = {
    hasError: false,
    pathname: undefined,
  };

  public state: State = this.defaultState;

  public static getDerivedStateFromError(error: Error) {
    // This may cause errors to be logged twice, but without this some errors
    // are not logged and reported in staging (and production?) environments.
    console.error(error);

    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch() {
    this.setState({ pathname: this.props.pathname });
  }

  public static getDerivedStateFromProps(props: Props, state: State) {
    if (state.pathname && props.pathname !== state.pathname) {
      return { hasError: false };
    }
    return null;
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorPage pageType="generic" />;
    }

    return this.props.children;
  }
}
